module.exports = __webpack_public_path__ + "img/place_longueuil.a7869c9b.png";